export enum ButtonTheme {
  primary = "primary",
  secondary = "secondary",
  tertiary = "tertiary",
}

export enum MessageTheme {
  status = "status",
  error = "error",
  success = "success",
  warning = "warning",
}

// Keep in sync with drupack/resources/config/_breakpoints.scss
export enum BreakpointSize {
  s = 426,
  m = 768,
  l = 1024,
  xl = 1440,
  xxl = 1650,
}

export interface IImage {
  image: string;
  preview?: string;
  alt?: string;
  title?: string;
  description?: string;
}

export enum VideoType {
  vimeo = "vimeo",
  youtube = "youtube",
}

export interface IVideo {
  url: string;
  title?: string;
  description?: string;
  iframe?: string;
  hasControls: boolean;
  type: VideoType;
}

export interface IEmbed {
  embed: string;
  allowEnlarge?: boolean;
  isSocialEmbed?: boolean;
  noEmbed?: boolean;
}

export interface IPager {
  onPageChange: (page: number) => void;
  currentPage: number;
  totalPages: number;
}

export interface ISingleBreadcrumb {
  text: string;
  url: string;
}

export interface IBreadcrumb extends ISingleBreadcrumb {
  isMultiLink?: boolean;
  links?: ISingleBreadcrumb[];
}

export enum EntityType {
  tool = "tool",
  page = "page",
  article = "article",
  dossier = "dossier",
  event = "event",
  subTool = "sub-tool",
}

export enum ToolType {
  poster = "poster",
  educationalMaterial = "educational_material",
  leaflet = "leaflet",
  game = "game",
  test = "test",
  video = "video",
  website = "website",
  policy = "policy",
}

export interface IAutosuggest {
  title: string;
  url: string;
  bundle: string;
}
export interface ISearchFilter {
  autosuggest?: IAutosuggest[];
  type: EntityType;
  apiUrl?: string;
  parentToolId?: string;
}

export enum TeaserHeadingType {
  h2,
  h3,
  h4,
}

export enum CookieCategories {
  necessary = "necessary",
  preferences = "preferences",
  statistics = "statistics",
  marketing = "marketing",
}

export enum Single {
  homepage = "homepage",
  search = "search",
  toolSearch = "toolSearch",
  toolOverview = "toolOverview",
  articleOverview = "articleOverview",
  dossierOverview = "dossierOverview",
  dossiersAZ = "dossiersAZ",
  eventArchive = "eventArchive",
  eventOverview = "eventOverview",
  toolboxSearch = "toolboxSearch",
}

export interface ILanguageSwitchItem {
  language: string;
  url: string;
  active: boolean;
}

export interface ILanguageSwitchData {
  [key: string]: ILanguageSwitchItem;
}
